import React, { Fragment } from "react";
import * as MUI from "@mui/material";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { Link } from "react-router-dom";
export default function TermsAndConditionsDe() {
  const { mode } = React.useContext(ThemeContext);
  return (
    <Fragment>
      <MUI.Typography variant="h3" sx={{ fontSize: { xs: "2rem" } }}>
        Nutzungsbedingungen
      </MUI.Typography>
      <MUI.Typography variant="h4">Datenschutzrichtlinie</MUI.Typography>
      <Fragment>
        <MUI.Stack spacing={4}>
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Einleitung").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Wir verpflichten uns, die Privatsphäre und Sicherheit Ihrer
              personenbezogenen Daten gemäß der Datenschutz-Grundverordnung
              (DSGVO) (EU-Verordnung 2016/679) zu schützen. Diese Richtlinie
              erläutert, wie wir Ihre personenbezogenen Daten bei der Nutzung
              unserer Plattform zur Verwaltung von Tierkliniken erfassen,
              verarbeiten und speichern. Unser Ziel ist es, Transparenz und
              Vertrauen zu gewährleisten, die Datenschutzgesetze einzuhalten und
              Ihre Daten verantwortungsvoll und sicher zu behandeln.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Sicherheitsmaßnahmen").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Wir verwenden branchenübliche Sicherheitsmaßnahmen zum Schutz
              Ihrer Daten, einschließlich Verschlüsselung, regelmäßiger
              Sicherheitsüberprüfungen und strenger Zugriffskontrollen, um
              unbefugten Zugriff zu verhindern.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Zugriff auf die Webseite").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Wenn Sie unsere Webseite aufrufen, übermittelt Ihr Browser
              bestimmte Daten an unseren Webserver. Die Datenübertragung erfolgt
              aus technischen Gründen, damit wir Ihnen die angeforderten
              Informationen zur Verfügung stellen können. Um Ihnen den Zugriff
              auf die Webseite zu erleichtern, werden folgende Daten erfasst,
              temporär gespeichert und verwendet:
            </MUI.Typography>
            <MUI.List sx={{ listStyleType: "disc" }}>
              <MUI.ListItem sx={{ display: "list-item" }}>
                IP-Adresse
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list-item" }}>
                Datum und Uhrzeit des Zugriffs
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list-item" }}>
                Zeitzonenunterschied zur Greenwich Mean Time (GMT)
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Inhalt der Anforderung (spezifische Seite)
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Zugriffsstatus/HTTP-Statuscode
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Übertragene Datenmenge
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Webseite, die den Zugriff anfordert
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Browser, Spracheinstellungen, Browserversion, Betriebssystem und
                Schnittstelle
              </MUI.ListItem>
            </MUI.List>
            <MUI.Typography>
              Darüber hinaus speichern wir zur Wahrung unserer berechtigten
              Interessen solche Daten für eine begrenzte Zeit, damit wir bei
              einem unbefugten Zugriff auf unsere Server oder einem Versuch
              eines solchen Zugriffs eine Verfolgung der personenbezogenen Daten
              einleiten können (Artikel 6 Absatz 1 Buchstabe f der
              Datenschutz-Grundverordnung).
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Von uns erfasste Daten").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Wir erfassen die folgenden Arten von Daten, um unsere
                Dienstleistungen anzubieten:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Personenbezogene Daten: Name, Telefonnummer, E-Mail-Adresse
                  und andere Kontaktdaten.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Haustierdaten: Name des Haustieres, Spezies, Rasse, Alter und
                  Gesundheitsdaten (z. B. Impfdaten, Behandlungen).
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Kontodaten: Benutzernamen, Passwörter und mit Ihrem Konto
                  verbundene Einstellungen.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Diese Daten ermöglichen es uns, Dienstleistungen wie die
                Terminplanung, die Verwaltung von Gesundheitsakten von
                Haustieren und eine effektive Kommunikation zwischen
                Tierbesitzern und Tierarztpersonal bereitzustellen.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Wie wir Ihre Daten verwenden").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Wir verarbeiten Ihre Daten für folgende Zwecke:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Einfachere Terminplanung und -reservierung.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Speicherung und Verwaltung von medizinischen Akten von
                  Haustieren für eine kontinuierliche Behandlung.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Ermöglichung einer genauen Kommunikation zwischen
                  Tierbesitzern und Tierarztpersonal.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Unterstützung interner Tools für die Geschäftsverwaltung der
                  Klinik.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Wir verarbeiten Ihre Daten ausschließlich zum Zweck der
                Bereitstellung und Verbesserung unserer Dienstleistungen.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Wer hat Zugriff auf Ihre Daten").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Der Zugriff auf Ihre personenbezogenen Daten ist auf
                autorisiertes Personal beschränkt:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Mitarbeiter der Tierklinik: Angestellte einer Klinik, die Sie
                  für die Behandlung Ihres Haustieres ausgewählt haben. Im Falle
                  eines Klinikwechsels hat die neu ausgewählte Klinik nur
                  Zugriff auf neue Daten, während die vorherige Klinik die
                  historischen Daten über erbrachte Dienstleistungen behält.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Anwendungsadministratoren: Autorisierte Mitarbeiter unseres
                  Unternehmens, die für die Wartung und Verbesserung der
                  Plattform verantwortlich sind.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Wir geben Ihre personenbezogenen Daten nicht an Dritte weiter,
                es sei denn, dies ist gesetzlich vorgeschrieben oder wir
                integrieren externe Dienste (z. B. Kassensysteme) mit Ihrer
                Zustimmung.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Ihre Rechte gemäß DSGVO").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Sie haben folgende Rechte bezüglich Ihrer Daten:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Auskunft: Einsicht in alle personenbezogenen Daten, die wir
                  über Sie gespeichert haben.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Berichtigung: Korrektur ungenauer Daten.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Löschung: Aufforderung zur Löschung Ihrer Daten, ausgenommen
                  gesetzlich vorgeschriebene Aufzeichnungen.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Datenübertragbarkeit: Anforderung einer Kopie Ihrer Daten in
                  einem strukturierten, maschinenlesbaren Format.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Widerruf der Einwilligung: Sie können Ihre Einwilligung zur
                  Datenverarbeitung jederzeit widerrufen.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Um diese Rechte auszuüben, kontaktieren Sie uns unter:{" "}
                <Link
                  color="inherit"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "mailto:info@kilobyte.hr";
                  }}
                >
                  info@kilobyte.hr
                </Link>
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Dauer der Datenaufbewahrung").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Wir speichern Ihre Daten, solange Ihr Konto aktiv ist. Wenn Sie
                Ihr Konto löschen, löschen wir alle damit verbundenen
                personenbezogenen Daten, es sei denn, dies ist gesetzlich oder
                betrieblich erforderlich. Zum Beispiel bleiben die Behandlungen,
                die Ihr Haustier erhalten hat, für die Klinik, die den Service
                erbracht hat, sichtbar.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Verwendung von Cookies").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                CENTAR ZA ZAŠTITU NA RADU verwendet Tools zur Analyse der
                Nutzung des Internetportals CENTAR ZA ZAŠTITU NA RADU und zur
                Erfassung bestimmter Informationen über Sie, um Einblicke in die
                Bedürfnisse unserer Besucher und/oder Nutzer zu gewinnen und so
                die Qualität unserer Angebote zu verbessern. In diesem
                Zusammenhang werden sogenannte Cookies und andere Tools
                verwendet.
              </MUI.Typography>
              <MUI.Typography>
                Der Nutzer und/oder Besucher kann Cookies über die
                entsprechenden Einstellungen in seinem Browser ablehnen oder
                löschen. Dies kann jedoch dazu führen, dass einige Funktionen
                des Internetportals CENTAR ZA ZAŠTITU NA RADU nicht mehr
                vollständig nutzbar sind.
              </MUI.Typography>
              <MUI.Typography>
                Die genannten Tools erfassen und speichern einige technische
                Daten, einschließlich der IP-Adresse des Nutzers und/oder
                Besuchers.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Dienste Dritter und globale Nutzung").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Obwohl wir derzeit in der EU tätig sind, ist unsere Plattform
              cloudbasiert, und Daten können auf Servern in anderen Ländern
              verarbeitet werden. Wir stellen sicher, dass alle internationalen
              Datenübertragungen den DSGVO-Standards entsprechen. Wenn wir
              Dienste von Dritten integrieren (z. B. Kassensysteme oder
              Analysen), stellen wir sicher, dass diese Dienstleister die DSGVO
              einhalten und unsere strengen Datenschutzstandards erfüllen.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Links zu anderen Webseiten").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Diese Webseite kann Links zu anderen Webseiten enthalten, die von
              anderen Organisationen mit eigenen spezifischen
              Datenschutzrichtlinien betrieben werden. Wir weisen Sie darauf
              hin, sich mit deren Nutzungsbedingungen und Datenschutzrichtlinien
              vertraut zu machen, bevor Sie personenbezogene Daten angeben, da
              CENTAR ZA ZAŠTITU NA RADU keine Verantwortung für diese Webseiten
              oder die Organisationen, die sie verwalten, übernimmt.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Aktualisierungen dieser Richtlinie").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Wir können diese Richtlinie regelmäßig aktualisieren, um
              Änderungen in den rechtlichen Anforderungen oder unseren
              Dienstleistungen widerzuspiegeln. Wesentliche Änderungen werden
              per E-Mail oder innerhalb der Anwendung mitgeteilt, bevor sie in
              Kraft treten.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Kontaktinformationen").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Wenn Sie Fragen, Bedenken oder Beschwerden bezüglich dieser
              Richtlinie haben, können Sie uns kontaktieren unter: E-Mail:{" "}
              <Link
                color="inherit"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "mailto:info@kilobyte.hr";
                }}
              >
                info@kilobyte.hr
              </Link>
            </MUI.Typography>
          </MUI.Stack>
        </MUI.Stack>
      </Fragment>
    </Fragment>
  );
}